var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrevArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 33,
  viewBox: "0 0 32 33",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 16.5L20 6.5L21.4 7.9L12.8 16.5L21.4 25.1L20 26.5L10 16.5Z",
  fill: "currenColor"
}))));
export { SvgPrevArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMiAzMyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMSI+CjxwYXRoIGQ9Ik0xMCAxNi41TDIwIDYuNUwyMS40IDcuOUwxMi44IDE2LjVMMjEuNCAyNS4xTDIwIDI2LjVMMTAgMTYuNVoiIGZpbGw9ImN1cnJlbkNvbG9yIi8+CjwvZz4KPC9zdmc+Cg==";